import type { FaireProductEntity } from "../../entity_types/product";

export const p_ngeekxngds: FaireProductEntity = {
  token: "p_ngeekxngds",
  type: "product",
  name: "Get It Done For Good Luck List Pad",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/8db9a31173f929aa64f02e31e3f1ad6c17f23f00e925a141db798561a2df4f0c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/219835ab467fa883fb3a1bd201e60756d0c791fc3271ac2719cb2800728bfe67.jpeg"
  ],
  priceDollars: 3,
  description: "A list notepad from our St. Patrick's Day Collection displaying an illustrated design featuring a horseshoe and a fun St. Patrick's Day inspired sentiment that reads \"Get It Done For Good Luck\" with a blank writing space underneath. Our Get It Done list pad includes 60 pages and a strong magnet to easily hang on magnetic surface for display. Proudly made in the USA. A fun St. Patrick's Day gift perfect for adding functional style to any space.",
  tags: [],
  msrpDollars: 5.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:08.244Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
